import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import FooterSubLink from './FooterSubLinks';
import { Translate } from '../../localization';
import Util from '../../helper/Util';
import { gameNames } from '../../config';

const options = ['en', 'zh(CN)', 'zh(TW)'];

const Footer = (props) => {
    const [selectedIndex, setSelectedindex] = useState(0);
    const { language } = useSelector((state) => state.general);
    const [casinoCategories, setCasinoCategories] = useState([
        'SLOT',
        'CRASH',
        'VIDEOPOKER',
        'INSTANTWIN',
    ]);

    const myStyles = {
        fontSize: '20px',
        padding: '10px',
      };

      const myStyles2 = {
          fontSize: '15px',
          padding: '10px',
        };

    useEffect(() => {
        let userSelectedLang = language;
        let userSelectedLangIndex = options.indexOf(userSelectedLang);
        if (userSelectedLangIndex !== selectedIndex) {
            Translate.setLanguage(userSelectedLang);
            setSelectedindex(userSelectedLangIndex);
        }
    }, []);

    let categories = casinoCategories.map((category, i) => {
        return (
            <li className='cursor-pointer' key={category} >
                <NavLink to={`/${Translate.getLanguage()}/d/casino/categories/${category}`}>
                    {Translate.tabNames[gameNames[Util.textCapitalize(category)]] || Translate.tabNames[Util.textCapitalize(category)]}
                </NavLink>
            </li>
        );
    });


    return (
        <footer>
            <div className='container'>
                <div className="footer-quick-listing-section">
                    <div className="d-none d-md-block">
                        <div className="row">
                            <div className="col-md-4">
                                <h6>{Translate.casinoGames}</h6>
                                <ul>
                                    {categories}
                                </ul>
                            </div>
                            <div className="col-md-4">
                                <h6>{Translate.support}</h6>
                                <ul>
                                    <li>
                                        <Link to={`/${Translate.getLanguage()}/d/support/contact-us`}>{Translate.contactUs}</Link>
                                    </li>
                                    <li>
                                        <Link to={`/${Translate.getLanguage()}/d/support/terms-and-conditions`}>{Translate.termsAndConditon}</Link>
                                    </li>
                                    <li>
                                        <Link to={`/${Translate.getLanguage()}/d/support/privacy-policy`}>{Translate.privacyPolicy}</Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-4">
                                <h6>{Translate.about}</h6>
                                <ul>
                                    <li>
                                        <Link to={`/${Translate.getLanguage()}/d/about/about-jackpotCT`}>{Translate.aboutZoobet}</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='mob-quick-link-wrap d-block d-md-none'>
                        <div className='container-fluid'>
                            <div className='row'>
                                <div className='col-7'>
                                    <h6> {Translate.casinoGames}</h6>
                                    <ul>
                                        {categories}
                                    </ul>
                                </div>
                                <FooterSubLink history={props.history} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="about-footer">
                    <div className="row justify-content-between align-items-center">
                        <div class="elementor-element elementor-element-70db82a elementor-widget elementor-widget-text-editor" data-id="70db82a" data-element_type="widget" data-widget_type="text-editor.default"><div class="elementor-widget-container"><p>JackpotCT website is operated by Mitratech Curacao B.V., a company incorporated under the laws of Curaçao with company registration number 146806, with its registered address at Zuikertuintjeweg Z/N (Zuikertuin Tower), Willemstad, Curaçao, licensed by Cyberluck Curaçao N.V. (Curaçao eGaming), with master license no. 1668/JAZ, authorized by the Government of Curaçao.</p></div></div>
                        <img width="80" height="80" src="/images/sports/logo.png" />
                        <img width="80" height="80" src="/images/tYO9lMIy_400x400.png" />
                        <img width="200" height="25" src="/images/begambleaware.png" class="attachment-full size-full wp-image-4946 lazyloaded" alt="BeGambleAwareOrg" data-eio="p" data-src="/images/begambleaware.png" decoding="async" data-eio-rwidth="243" data-eio-rheight="31" />
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
